import { Link } from 'react-router-dom';
import { categories } from '@/mocks/shows';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl" style={{ color: 'oklch(var(--primary-500))' }}></i>
              </span>
              <span className="text-lg font-heading font-bold text-foreground-100">天狼影院</span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400 mb-4">
              天狼影院提供电视剧全集连播，最新剧集高清免费在线观看，流畅不缓冲，海量剧集每日更新，满足追剧需求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">影视分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">热门推荐</h4>
            <ul className="space-y-2.5">
              <li><Link to="/detail/2" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">狂飙</Link></li>
              <li><Link to="/detail/4" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">庆余年第二季</Link></li>
              <li><Link to="/detail/3" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">流浪地球2</Link></li>
              <li><Link to="/detail/1" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">长安十二时辰</Link></li>
              <li><Link to="/detail/10" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">三体</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">关于本站</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">用户口碑</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">联系我们</Link></li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-foreground-400 hover:text-primary-400 hover:bg-background-600 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-foreground-400 hover:text-primary-400 hover:bg-background-600 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-foreground-400 hover:text-primary-400 hover:bg-background-600 transition-colors duration-200 cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/60 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 天狼影院 - 高清免费在线追剧平台。本站内容均来自网络，仅供学习交流。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}